export const crmStatusOptions = [
  { value: "new", label: { ar: "جديد", en: "New" } },
  { value: "in_progress", label: { ar: "جاري التنفيذ", en: "In Progress" } },
  { value: "active", label: { ar: "فعال", en: "Active" } },
  { value: "potential", label: { ar: "محتمل", en: "Potential" } },
  { value: "trial_active", label: { ar: "تجربة فعالة", en: "Trial Active" } },
  { value: "quote_sent", label: { ar: "عرض سعر", en: "Quote Sent" } },
  { value: "inactive", label: { ar: "غير فعال", en: "Inactive" } },
];

export const dateStatusOptions = [
  { value: "asap", label: { ar: "في أسرع وقت", en: "ASAP" } },
  { value: "urgent", label: { ar: "عاجل", en: "Urgent" } },
  { value: "waiting", label: { ar: "انتظار", en: "Waiting" } },
  { value: "date", label: { ar: "موعد", en: "Date" } },
];

export const emptyForm = {
  onboarding: {
    _id: "",
    store: {
      businessName: "",
      branchCount: 1,
      city: "",
      ownerName: "",
      contactNumber: "",
      email: "",
      branches: [],
    },
    contact: { jobTitle: "", contactName: "", mobile: "", email: "" },
    entity: {
      entityName: "",
      commercialRegistration: "",
      crExpiration: "",
      vatNumber: "",
    },
    documents: { files: [], notes: "" },
    quotation: {},
    workFlow: { currentStage: 1, status: "draft", history: [] },
  },
  isDuplicate: false,
  isSelfClient: false,
  crm: {
    status: "new",
    followUpEndDate: "",
    dateStatus: "asap",
    assignedUser: "",
  },
};

export const setNestedValue = (obj, path, value) => {
  const keys = path.split(".");
  const lastKey = keys.pop();

  const newObj = Array.isArray(obj) ? [...obj] : { ...obj };
  let current = newObj;

  for (const key of keys) {
    const next = current[key];

    if (Array.isArray(next)) {
      current[key] = [...next];
    } else {
      current[key] = { ...next };
    }

    current = current[key];
  }

  current[lastKey] = value;
  return newObj;
};

export const deepMerge = (target, source) => {
  const output = { ...target };
  for (const key in source) {
    if (
      typeof source[key] === "object" &&
      source[key] !== null &&      !Array.isArray(source[key])
    ) {
      output[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      output[key] = source[key];
    }
  }
  return output;
};
